import { render } from "./GalleriaThumbnails.vue?vue&type=template&id=ac0f27de"
import script from "./GalleriaThumbnails.vue?vue&type=script&lang=js"
export * from "./GalleriaThumbnails.vue?vue&type=script&lang=js"
script.render = render

export default script